/* 首頁 */
export const ROOT_PAGE_HOME = '/home';
